import {
	NgModule,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { App } from './app';
import { I18nPipe } from './shared/pipe/i18n-pipe';
import { ImageSrcPipe } from './shared/pipe/image-src-pipe';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authTokenInterceptor } from './shared/interceptors/auth-token.interceptor';
import { mockBackendInterceptor } from './shared/interceptors/mock-backend.interceptor';
import { GuidedSetup } from './guided-setup/guided-setup';
import { GuidedSetupDialog } from './guided-setup/guided-setup-dialog';
import { SipOrder } from './sip-order/sip-order';
import { Note } from './note/note';
import { CallbackOnCallnote } from './callback-on-callnote/callback-on-callnote';
import { FormFieldList } from './note/form-field-list/form-field-list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { PriceInfoDialog } from './price-info-dialog/price-info-dialog';
import { Error } from './error/error';
import { ErrorCallbackCreation } from './callback-on-callnote/error-callback-creation/error-callback-creation';
import { Success } from './callback-on-callnote/success/success';
import { CallnoteFeedback } from './callnote-feedback/callnote-feedback';
import { CallerEditDialog } from './caller-edit-dialog/caller-edit-dialog';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TextFieldModule } from '@angular/cdk/text-field';

@NgModule({
	declarations: [
		GuidedSetup,
		GuidedSetupDialog,
		SipOrder,
		App,
		I18nPipe,
		ImageSrcPipe,
		Note,
		CallbackOnCallnote,
		FormFieldList,
		PriceInfoDialog,
		Error,
		ErrorCallbackCreation,
		Success,
		CallnoteFeedback,
		CallerEditDialog,
	],
	imports: [
		BrowserModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		MatRadioModule,
		ReactiveFormsModule,
		MatDatepickerModule,
		MatTimepickerModule,
		MatTooltipModule,
		MatDialogModule,
		MatSlideToggle,
		MatCheckboxModule,
		MatSelectModule,
		TextFieldModule,
	],
	providers: [
		I18nPipe,
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		// PS-6495: the bearer is attached by a path allowlist, default deny. See
		// auth-token.interceptor.ts — adding a path there is a deliberate review decision.
		// mockBackendInterceptor is FIRST on purpose: in mock mode a request is answered before the
		// bearer interceptor can even attach a token, and nothing downstream can reach the network.
		// TEMPORARY, with the rest of the PS-6495 mock harness.
		provideHttpClient(withInterceptors([mockBackendInterceptor, authTokenInterceptor])),
		provideNativeDateAdapter(),
		{ provide: MAT_DATE_LOCALE, useValue: 'en-DE' },
	],
	bootstrap: [App],
})
export class AppModule {}
